// src/app/components/searshForms/searchUrl.js

/* URL de la page résultats pour une recherche. Seuls les critères
   renseignés partent dans l'URL (pas de « adult=0 » ni de « destination= »). */
export const buildSearchUrl = ({
  destination = "",
  startDate = "",
  endDate = "",
  adults = 0,
  children = 0,
  babies = 0,
} = {}) => {
  const params = new URLSearchParams(
    Object.entries({
      destination: (destination || "").trim(),
      startDate,
      endDate,
      adult: adults,
      child: children,
      baby: babies,
    }).filter(([, v]) => v !== "" && v !== 0 && v !== null && v !== undefined)
  ).toString();

  return `/trips${params ? `?${params}` : ""}`;
};
